import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { HOME } from "@/constants/testIds";
import { useLang } from "@/i18n/LangContext";

export default function Navbar({ dark = false }) {
  const loc = useLocation();
  const isHome = loc.pathname === "/";
  const { lang, setLang, t } = useLang();

  const toggleLang = () => setLang(lang === "en" ? "hi" : "en");

  return (
    <motion.nav
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 0.2, ease: [0.7, 0, 0.2, 1] }}
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        background: dark ? "rgba(26,26,26,0.85)" : "rgba(244,241,234,0.82)",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
        borderBottom: `1px solid ${dark ? "rgba(255,255,255,0.08)" : "var(--line)"}`,
        color: dark ? "#F4F1EA" : "var(--ink)",
      }}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <span
            className="serif text-xl md:text-2xl leading-none"
            style={{ letterSpacing: "-0.02em" }}
          >
            Pritam P. Aggarwal
          </span>
          <span className="hidden md:inline mono-eyebrow" style={{ color: dark ? "#a3a3a3" : "var(--mute)" }}>
            &nbsp;{t("brand.tagline")}
          </span>
        </Link>
        <div className="flex items-center gap-5 md:gap-8">
          {isHome ? (
            <>
              <a href="#howitworks" className="hidden md:inline link-underline text-sm" data-testid="nav-about">
                {t("nav.chapters")}
              </a>
              <a href="#services" className="hidden md:inline link-underline text-sm" data-testid="nav-services">
                {t("nav.practice")}
              </a>
              <a href="#booking" className="hidden md:inline link-underline text-sm" data-testid="nav-booking">
                {t("nav.booking")}
              </a>
            </>
          ) : (
            <Link to="/" className="hidden md:inline link-underline text-sm" data-testid="nav-home">
              {t("nav.home")}
            </Link>
          )}
          <button
            data-testid="lang-toggle"
            onClick={toggleLang}
            aria-label="Toggle language"
            className="mono-eyebrow border inline-flex items-center justify-center"
            style={{
              borderColor: dark ? "rgba(255,255,255,0.2)" : "var(--ink)",
              color: dark ? "#F4F1EA" : "var(--ink)",
              fontSize: 11,
              letterSpacing: "0.15em",
              minWidth: 44,
              height: 28,
              padding: "0 8px",
              fontFamily: '"Noto Sans Devanagari", Manrope, sans-serif',
            }}
          >
            {lang === "en" ? "हिं" : "EN"}
          </button>
          <Link to="/book" data-testid={HOME.navBook} className="btn-terra !py-3 !px-5 !text-[11px]">
            {t("nav.book")}
          </Link>
        </div>
      </div>
    </motion.nav>
  );
}
